/// <amd-module name="Wit/UI/ComponentProviders/BaseProvider/BaseProviderComponent" />
import * as React from "react";
import * as PropTypes from "prop-types";
import { IBaseProviderProps } from "./BaseProviderComponent.Props";

/**
 * Base provider component for wit ui controls
 */
export class BaseProviderComponent<P extends IBaseProviderProps, S = {}> extends React.Component<P, S> {
    private _componentMounted = false;

    static propTypes = {
        children: PropTypes.func.isRequired
    };

    constructor(props: P, context?: any) {
        super(props, context);
    }

    public componentDidMount(): void {
        this._componentMounted = true;
    }

    public componentWillUnmount(): void {
        this._componentMounted = false;
    }

    public componentMounted(): boolean {
        return this._componentMounted;
    }
}
